import * as React from 'react';
import { Card as CardMui, Collapse, Grid } from '@mui/material';
import { Button, GridContainer, Popover, Text } from '.';
import { direction } from '../services/app.service';

interface Props {
  id?: string;
  header?: any;
  popOver?: string;
  color?: any;
  direction?: direction;
  gradientColor?: any;
  borderColor?: any;
  borderRadius?: number;
  borderWidth?: number;
  boxShadow?: number;
  padding?: number;
  width?: any;
  fullHeight?: boolean;
  collapse?: boolean;
  selected?: boolean;
  mediaAsBackground?: boolean;
  sx?: any;
  onClick?: () =>void;
  media?: React.ReactNode;
  children?: React.ReactNode;
  
}

export const Card: React.FunctionComponent<Props> = (props) => {
  const [collapse, setCollapse] = React.useState(props.collapse);
  const [hover, setHover] = React.useState({});
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const gridWidth = props.direction?.startsWith('row')? 4 : 12;
  const gradient = {background: 'linear-gradient(90deg, ' + props.gradientColor + ', transparent)'};

  const onMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    if (props.popOver) setAnchorEl(e.currentTarget);
  }

  const onMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    if (props.popOver) setAnchorEl(null);
  }

  React.useEffect(() => {
    if (props.boxShadow)
      setHover({ boxShadow: props.boxShadow, backgroundColor: props.selected? 'background.default': 'background.paper' });

    setCollapse(props.collapse)
  }, [props.gradientColor, props.boxShadow, props.selected, props.collapse])

  return (
    <>
    {props.children || props.media?
    <Grid id={props.id} display={props.fullHeight? 'flex' : ''} height={props.fullHeight? '100%' : 'auto'} width={props.width || '100%'} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <CardMui variant='outlined'  sx={{...gradient, backgroundColor: props.color || (props.selected? 'background.default' : 'white'), borderWidth: (props.borderWidth === 0? 0 : props.borderWidth || 1), borderColor: props.borderColor || (props.selected? 'primary.main':'primary.light'), borderRadius: props.borderRadius || 5, ':hover': hover, ...props.sx }}>
        {props.header && 
        <GridContainer sx={{bgcolor: props.header?.bgColor, borderRadius: props.borderRadius || 5, pl: 2, pr: 1}}>
          <Text label={props.header?.caption} size={props.header?.size || 'large'} color={props.header?.color} bold textAlign={props.header?.textAlign} icon={props.header?.icon} iconColor={props.header?.iconColor} />
          <Button startIcon={collapse? 'keyboard_arrow_right' : 'keyboard_arrow_down'} color={props.header?.color} onClick={() => setCollapse(!collapse)} />
        </GridContainer>
        }
        <Collapse in={!collapse} timeout='auto' unmountOnExit>
          <Grid position='relative' container direction={props.direction}>
            {props.media? <Grid position='relative' container item xs={gridWidth} md={gridWidth} alignItems='start' justifyContent='center' sx={{backgroundColor: props.gradientColor}}> {props.media} </Grid> :''}
            {props.children? <Grid position={props.mediaAsBackground? 'absolute' : 'unset'} container={props.boxShadow===0} item xs={(12 - gridWidth) || 12} md={(12-gridWidth) || 12} alignItems='center' width={props.width || '100%'} sx={{...gradient, bottom: 20}} p={props.padding || 2} pt={props.header? 0 : -1}> <Grid container={props.boxShadow === 0}>{props.children}</Grid> </Grid> :''}
          </Grid>
        </Collapse>
      </CardMui>
      <Popover value={props.popOver} anchorEl={anchorEl} />
    </Grid>    
    :''
    }
    
    </>
  )
}


